import { HubItemCategoryPermissionModel } from "../Hub/hubItemCategories";
import { environmentHttpClient } from "../httpClient";

export type AnnouncementCategoryListItemModel = {
	id: number;
	name: string;
	description: string;
	published: number;
	planned: number;
	permissions: HubItemCategoryPermissionModel;
};

export type AnnouncementCategoryListModel = {
	canCreateNewCategories: boolean;
	categories: AnnouncementCategoryListItemModel[];
};

export function listCategories(signal?: AbortSignal): Promise<AnnouncementCategoryListModel> {
	return environmentHttpClient.get<AnnouncementCategoryListModel>(
		"UiApi/AnnouncementCategories/List",
		undefined,
		{ signal }
	);
}